import { ProductCharacteristic } from 'features/product-characterstics';
import { ViewsModels } from 'features/reviews';
import { ReviewsValidations } from 'utils/domain-specifics/reviews/validation';

export const BRAND_CHARACTERISTICS_KEY = 'brand';

export const getBrandCharacteristic = (characteristics: ProductCharacteristic[] = []) => {
  const brandCharacteristics = characteristics.filter(({ key }) => key === BRAND_CHARACTERISTICS_KEY);
  return brandCharacteristics.length ? brandCharacteristics[0].definition : '';
};

export const getAggregationRatings = (reviewTotalScore?: ViewsModels.ReviewScoreTotal) => {
  const totalScore = reviewTotalScore?.score ?? null;
  const reviewsCount = reviewTotalScore?.count ?? null;
  if (
    typeof totalScore === 'number' &&
    ReviewsValidations.isRatingValueValid(totalScore) &&
    typeof reviewsCount === 'number' &&
    ReviewsValidations.isNumberOfRatingsValid(reviewsCount) &&
    reviewsCount > 0
  ) {
    return {
      totalScore: totalScore?.toFixed(1),
      reviewsCount: reviewsCount?.toFixed(0),
    };
  }
};
